import { DateJump, type PeriodMode } from '@/ui/DateJump';
import { Icon } from '@/ui/icons';
import type { ReactNode } from 'react';
import s from './PeriodControl.module.css';

/**
 * Previous, the period (opens the calendar), next: one neutral-button family on every page that
 * steps through days, weeks or months (#154 VF-02, VF-07). It owns its look; a page places it.
 * `className` is for the page's layout only (`mstep` is kept as that hook), never for restyling
 * the buttons. `extra` sits after next, for a page's own «I dag».
 */
export function PeriodControl({
  value,
  onChange,
  month,
  period,
  onPrev,
  onNext,
  prevLabel,
  nextLabel,
  label,
  children,
  extra,
  className,
}: {
  value: string;
  onChange: (value: string) => void;
  month?: boolean;
  period?: PeriodMode;
  onPrev: () => void;
  onNext: () => void;
  prevLabel: string;
  nextLabel: string;
  /** the group's name, read before its buttons */
  label?: string;
  /** what the period reads, inside the calendar button */
  children: ReactNode;
  extra?: ReactNode;
  className?: string;
}) {
  return (
    <fieldset aria-label={label} className={`mstep ${s.root}${className ? ` ${className}` : ''}`}>
      <button type="button" className={s.step} aria-label={prevLabel} onClick={onPrev}>
        <Icon name="chevronLeft" />
      </button>
      <DateJump
        value={value}
        onChange={onChange}
        {...(month !== undefined ? { month } : {})}
        {...(period !== undefined ? { period } : {})}
        className={s.jump ?? ''}
      >
        {children}
      </DateJump>
      <button type="button" className={s.step} aria-label={nextLabel} onClick={onNext}>
        <Icon name="chevronRight" />
      </button>
      {extra}
    </fieldset>
  );
}
